import React from 'react'

const BLOCKQUOTE_STYLES = 'flex flex-col m-0 box-border bg-secondary p-8'

const QUOTE_STYLES =
  'box-border text-sm md:text-lg font-heading italic text-contentareabackground m-auto text-center'

const AUTHOR_STYLES =
  'text-xs md:text-sm font-heading text-accent mt-2 mx-auto mb-auto'

const ICON_STYLES = 'mt-4 mx-auto mb-auto h-12 opacity-75'

export interface ISplashQuoteProps {
  icon?: string | JSX.Element
  quote: string
  author?: string
  title?: string
}

export const SplashQuote: React.FC<ISplashQuoteProps> = ({
  quote,
  author,
  icon,
  title,
}) => (
  <blockquote className={BLOCKQUOTE_STYLES}>
    <div className={QUOTE_STYLES}>{quote}</div>
    {author ? (
      <div className={AUTHOR_STYLES}>
        <cite>{author}</cite>
        {title ? ',' : ''} {title}
      </div>
    ) : null}
    {icon ? <div className={ICON_STYLES}>{icon}</div> : null}
  </blockquote>
)
